import React from 'react'
import styled from 'styled-components'
import { SIZES } from '../styles/theme'
import { useObject } from 'react-firebase-hooks/database'
import { NoticeDb } from '../firebaseConfig'

const Wrapper = styled.div`
  min-height: ${({ $overlay }) => ($overlay ? '0' : '30px')};
  marquee {
    ${SIZES.noticeBar}
    position: fixed;
    left: 0;
    right: 0;
    background: var(--Gold-Gradient-01, linear-gradient(90deg, #ae8341 0%, #f2c370 50%, #ae8341 100%));
    z-index: 300;
    color: #262c65;
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 1px;
    padding: 2px 0;
    span {
      margin: 0 0.8em;
    }
  }
`

export default function NoticeBar({ overlay = false }) {
  const [snapshot, loading, error] = useObject(NoticeDb)

  if (loading || error) {
    return <></>
  }

  return (
    <Wrapper $overlay={overlay}>
      <marquee scrollamount={5}>
        <span className="font-weight-bold">{snapshot.val()}</span>
      </marquee>
    </Wrapper>
  )
}
